var _defs, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmoLogoEmblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #5ec1a0;\n      }\n\n      .st1 {\n        fill: #f5933c;\n      }\n\n      .st2 {\n        fill: #ec438b;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120,
    cy: 194.5,
    r: 45.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.5,45.5c0,7.5-2,15-5.5,21.5-3.5,6.5-8.5,12-14,16-1,1-2.5,1.5-3.5,2.5-6.5,3.5-14,6-22,6s-15.5-2-22.5-6c-1-.5-2.5-1.5-3.5-2.5-12-8-19.5-22-19.5-37.5C74.5,20.5,95,0,120,0s45.5,20.5,45.5,45.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146,82.5c-1,1-2.5,1.5-3.5,2.5,0,0-.5,0-1,1l-11.5,11.5c-5.5,5.5-14.5,5.5-20,0l-11.5-11.5-1-1c-1-.5-2.5-1.5-3.5-2.5-2-1-3.5-1-5.5-1-7,0-14,5.5-14,14v40c0,7.5,6,14,14,14h63c7.5,0,14-6,14-14v-40c0-10.5-11-16.5-19.5-13ZM159,108c0,1.5-1.5,3-3,3s-3-1.5-3-3v-12c0-1.5,1.5-3,3-3s3,1.5,3,3v12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159,96v12c0,1.5-1.5,3-3,3s-3-1.5-3-3v-12c0-1.5,1.5-3,3-3s3,1.5,3,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmoLogoEmblem);
export default __webpack_public_path__ + "static/media/OMO-Logo-Emblem.2d9fcf373c676012a5de18309f0b8b5c.svg";
export { ForwardRef as ReactComponent };